



















































































import VueBase from '@/VueBase'
import { Component } from 'vue-property-decorator'

@Component({ name: 'templateManage' })
export default class templateManage extends VueBase {
  private templateForm: any = {
    content: [],
    fid: 1,
    name: '',
  }
  private isSelectAll = false
  private strategyTypeList: Array<{
    level_id: number
    level_name: number
    type_value: Array<{
      strategy_id: number
      level_id: number
      state: string
      vul_name: string
    }>
  }> = []
  private checkIdChange(id: number) {
    if (this.$route.query.view) {
      return
    }
    const idSet = new Set([...this.templateForm.content])
    if (idSet.has(id)) {
      idSet.delete(id)
    } else {
      idSet.add(id)
    }
    this.templateForm.content = [...idSet]
    this.isAllSelect()
  }
  private selectAllChange() {
    const idSet = new Set([...this.templateForm.content])
    this.strategyTypeList[
      this.strategyTypeList.findIndex(
        (i: { level_id: number }) => i.level_id === this.templateForm.fid
      )
    ].type_value.forEach(
      (item: {
        strategy_id: number
        level_id: number
        state: string
        vul_name: string
      }) => {
        if (this.isSelectAll) {
          idSet.add(item.strategy_id)
        } else {
          idSet.delete(item.strategy_id)
        }
      }
    )
    this.templateForm.content = [...idSet]
  }

  isAllSelect() {
    const idSet = new Set([...this.templateForm.content])
    this.isSelectAll = this.strategyTypeList[
      this.strategyTypeList.findIndex(
        (i: { level_id: number }) => i.level_id === this.templateForm.fid
      )
    ].type_value.every(
      (item: {
        strategy_id: number
        level_id: number
        state: string
        vul_name: string
      }) => {
        return idSet.has(item.strategy_id)
      }
    )
  }

  private async strategyTypes() {
    this.loadingStart()
    const { status, msg, data } = await this.services.setting.strategyTypes()
    this.loadingDone()
    if (status !== 201) {
      this.$message({
        type: 'error',
        message: msg,
        showClose: true,
      })
      return
    }
    data
      .reduce(
        (
          list: any[],
          item: {
            level_id: number
            level_name: number
            type_value: Array<{
              strategy_id: number
              level_id: number
              state: string
              vul_name: string
            }>
          }
        ) => {
          list = [...list, ...item.type_value]
          return list
        },
        []
      )
      .forEach(
        (item: {
          strategy_id: number
          level_id: number
          state: string
          vul_name: string
        }) => {
          if (item.state === 'enable') {
            this.templateForm.content.push(item.strategy_id)
          }
        }
      )
    this.strategyTypeList = data
  }

  private rules = {
    name: [
      {
        required: true,
        message: this.$t('views.templateManage.nameR') as string,
        trigger: 'blur',
      },
    ],
  }

  async templateAdd() {
    // 新增确认
    this.loadingStart()
    const res = await this.services.setting.create_scan_strategy(
      this.templateForm
    )
    this.loadingDone()
    if (res.status === 201) {
      this.$message.success(res.msg)
      this.goBack()
    } else {
      this.$message.error(res.msg)
    }
  }
  async templateEdit() {
    // 编辑确认
    this.loadingStart()
    const res = await this.services.setting.update_scan_strategy(
      this.templateForm
    )
    this.loadingDone()
    if (res.status === 201) {
      this.$message.success(res.msg)
      this.goBack()
    } else {
      this.$message.error(res.msg)
    }
  }
  async templateDialogEdit() {
    // 编辑获取数据
    const res = await this.services.setting.get_scan_strategy_one({
      id: this.$route.query.id,
    })
    if (res.status === 201) {
      this.templateForm.id = res.data.id
      this.templateForm.name = res.data.name
      this.templateForm.content = res.data.content
      this.templateForm.status = res.data.status
      this.isAllSelect()
    } else {
      this.$message.error(res.msg)
    }
  }
  templateDialogEnter() {
    const form: any = this.$refs.ruleForm
    form.validate((valid: boolean) => {
      if (valid) {
        if (this.$route.query.id) {
          this.templateEdit()
        } else {
          this.templateAdd()
        }
      }
    })
  }
  async goBack() {
    this.$router.push({ name: 'templateManage' })
  }
  async created() {
    this.loadingStart()
    await this.strategyTypes()
    if (this.$route.query.id) {
      await this.templateDialogEdit()
    }
    this.loadingDone()
  }
}
